import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Input, Label, Button, Form } from "reactstrap";
import { get, put, post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { useNavigate, useParams } from "react-router-dom";
import Loader from "common/loader";
import UploadImage from "common/uploadImage";
import { SHOW_STATUS, UPDATE_STATUS, ADD_STATUS } from "helpers/api_endpoints";

//meta title
document.title = "Edit Status";

const EditStatus = () => {

    const [loading, setLoading] = useState(true);
    const params = useParams();
    const [id, setid] = useState('');
    const [status, setStatus] = useState(0);
    const [notify, setNotify] = useState(0);
    const [name, setname] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        get(`${SHOW_STATUS}/${params.id}`)
            .then(response => {
                const status = response.data;
                setid(params.id);
                setname(status.name);
                setStatus(status.status);
                setNotify(status.notify);
                setLoading(false);
            })
            .catch(error => {
                console.log(error)
                navigate('/status');
            })
    }, []);

    const handleSubmit = () => {
        console.log()
        // const imagePath = document.getElementById('imagePath').value;
        const config = { id, name, status, notify };
        // if(anew == 1)
        // {
        //     delete config.id;
        //     post(ADD_STATUS, config)
        //     .then(response => {
        //         if (response.code == 200) {
        //             navigate('/status', { state: { successMsg: 'Added SuccessFully' } });
        //         }
        //     })
        //     .catch(error => {
        //         console.log(error.response);
        //     })
        // }
        // else
        {
            put(UPDATE_STATUS, config)
                .then(response => {
                    if (response.code == 200) {
                        navigate('/status', { state: { successMsg: 'Updated SuccessFully' } });
                    }
                })
                .catch(error => {
                    console.log(error.response);
                })
        }
    }

    const handleToggleCheckBoxStatus = () => {
        if (status) {
            setStatus(0);
        }
        else {
            setStatus(1)
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Offers" breadcrumbItem="Edit Status" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        {loading ? <Loader></Loader> :
                                            <Row>
                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Name</Trans></Label>
                                                    <Input
                                                        name="name"
                                                        value={name}
                                                        className="form-control"
                                                        placeholder="Enter  Name"
                                                        type="text"
                                                        onChange={(e) => setname(e.target.value)}
                                                        required ></Input>
                                                </div>

                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Status</Trans></Label>
                                                    <div className="form-check form-check-end">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            value={1}
                                                            id="defaultCheck2"
                                                            checked={status == 1}
                                                            onClick={handleToggleCheckBoxStatus}
                                                        />
                                                        <label
                                                            className="form-check-label"
                                                            htmlFor="defaultCheck2"
                                                        >
                                                            <Trans>Active</Trans>
                                                        </label>
                                                    </div>
                                                </div>

                                                <div className="form-group col-md-2 mt-2">
                                                    <Label className="form-label"><Trans>Notify</Trans></Label>
                                                    <Input
                                                        name="notify"
                                                        value={notify}
                                                        className="form-control"
                                                        placeholder=""
                                                        type="number"
                                                        onChange={(e) => setNotify(e.target.value)}
                                                        required 
                                                        ></Input>
                                                </div>


                                                <div className="mt-4">
                                                    <Button type="submit" color="danger">
                                                        <Trans>Submit</Trans>
                                                    </Button>
                                                    <Button type="submit" onClick={(e) => setNew(1)} color="info">
                                                        <Trans>Submit As New</Trans>
                                                    </Button>
                                                </div>
                                            </Row>
                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default EditStatus
